module.exports = "pegasus/assets/styleGroup2-twitter.png";